import React from "react";
import {
	formatDateAdded,
	isAdmin
} from "./../../../../util";
import { FaEdit, FaTrash, FaInfoCircle, FaUpload, FaFilePdf, FaFileExcel, FaNewspaper, FaFileInvoiceDollar, FaAws, FaFileExport, FaCloudUploadAlt } from "react-icons/fa";

export const dandOEntriesColumns =  ({
	routeName,
	className, enableDandO, enableView,
	firmSettings,
	goToCases,
	handleEnable,
	handleEdit,
	handleTrash,
	handleInfo,
	handleViewer,
	handleFileUpload,
	handleRiskImport,
	handleCompanyRisk
}) => {

	const isAdminToken = isAdmin();
	const classForCompanyNameColumn = ["/CaseManagement", "/cases", "/CustomCaseManagement", "/DandOManagement"].indexOf(routeName) !== -1 && " cursorPointer";

	let columns = [];
	if(isAdminToken) {
		const adminClassName = className + "Admin"
		columns = [
			{
				title: "Firm Name",
				name: "firmId",
				format: (firmId) => firmId.substr(1),
				colNum: 1,
				className: adminClassName,
				textAlign: 'left',
				sortyBy: 'firmName',
			},
			{
				title: "Company Name",
				name: "companyName",
				colNum: 2,
				className: adminClassName + classForCompanyNameColumn,
				onClick: goToCases,
				params: "dandoId",
				textAlign: 'left',
				sortyBy: 'companyName',
			},
			{
				title: "Ticker",
				name: "ticker",
				className: adminClassName,
				colNum: 3,
				sortyBy: 'ticker',
			},
			{
				title: <span>Risk Assess. <br></br>Date</span>,
				name: "riskAssessmentDate_UI",
				className: adminClassName,
				colNum: 4,
				sortyBy: 'riskAssessmentDate',
			},
			{
				title: "Date Added",
				name: "dateAdded",
				className: adminClassName,
				colNum: 5,
				format: (dateAdded) => formatDateAdded(dateAdded),
				sortyBy: 'dateAdded',
			},
			{
				title: "Status",
				name: "status",
				className: adminClassName,
				colNum: 6,
				hidden: !enableDandO,
				sortyBy: 'status',
			},
			{
				title: "Options",
				noSort: true,
				colNum: 7,
				hidden: !(isAdminToken === true && enableView === false),
				className: adminClassName,
				format: (filledCase) => <React.Fragment>
					<label className="switch-container">
						<input
							// ref="switch"
							value={filledCase.enabled}
							checked={filledCase.enabled}
							onChange={evt => handleEnable(filledCase, evt.target.value, "enabled")}
							className="switch"
							type="checkbox"
						/>
						<div>
							<div></div>
						</div>
					</label>

					<FaEdit
						title="Edit"
						className="editBtn"
						onClick={() => handleEdit(filledCase)}
					/>

					<FaTrash
						title="Delete"
						className="editBtn"
						onClick={() => handleTrash(filledCase)}
					/>
					
					<FaInfoCircle
						title="Notes"
						className="editBtn"
						onClick={() => handleInfo(filledCase)}
					/>
					
					<FaUpload
						title="File Upload"
						className="editBtn"
						onClick={() => handleFileUpload(filledCase)}
					/>
					<FaFileExport
						title="Generate Input Files"
						className="editBtn"
						onClick={() => handleRiskImport(filledCase.dandoId)}
					/>
					<FaCloudUploadAlt
						title="Run Risk"
						className="editBtn"
						onClick={() => handleCompanyRisk(filledCase.dandoId)}
					/>
					
				</React.Fragment>
			},
			{
				title: "Files",
				noSort: true,
				hidden: !(isAdminToken === true && enableView === false),
				className: adminClassName+"Option",
				format: (filledCase) => <React.Fragment>
					{
						filledCase.s3URL.length > 0 && (
							<FaAws
								title="View S3 Files"
								className="editBtn"
								onClick={() => window.open(filledCase.s3URL, '_blank').focus()}
							/>
						)
					}

					{
						filledCase.dataURL.length > 0 && (
							<FaFileInvoiceDollar
								title="View Data Input"
								className="editBtn"
								onClick={() => window.location.href=filledCase.dataURL}
							/>
						)
					}

					{
						filledCase.newsURL.length > 0 && (
							<FaNewspaper
								title="View News Input"
								className="editBtn"
								onClick={() => window.location.href=filledCase.newsURL}
							/>
						)
					}

					{filledCase.pdfURL.length > 0 && (<FaFilePdf
						title="Open PDF Risk Report"
						className="editBtn"
						onClick={() => handleViewer(filledCase.pdfURL, 'pdf')}
					/>)}

					{filledCase.excelURL.length > 0 && (<FaFileExcel
						title="Open Excel Risk Report"
						className="editBtn"
						onClick={() => handleViewer(filledCase.excelURL, 'xlsx')}
					/>)}
				</React.Fragment>
			}
		];
	} 

	return columns;
}


// WEBPACK FOOTER //
// ./src/common/components/TableGrid/tableColumn/DandOEntriesColumns.js